<div
  *ngIf="isLoading"
  class="tabla-loader-card"
  role="status"
  aria-live="polite">
  <div class="spinner"></div>
  <h3>{{ title }}</h3>
  <p *ngIf="message">{{ message }}</p>
</div>

<!--     
================METODO DE USO================
  <app-loading-admisiones
  [isLoading]="cargandoComisiones"
  title="Cargando comisiones"
  message="Por favor espere un momento.">
</app-loading-admisiones>

-->